<template>
  <div>
    <h5 class="file-info-title mb-2">{{ $t('mediaObject.info') }}</h5>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-three-line"
    />
    <div v-else class="file-info-container">
      <div class="info-row background-accent">
        <span class="info-label">
          {{ $t("mediaObject.fileName") }}:
        </span>
        <span class="info-value">
          {{ fileName ? fileName : $t("unknown") }}
        </span>
      </div>
      <div class="info-row">
        <span class="info-label">
          {{ $t("mediaObject.fileSize") }}:
        </span>
        <span class="info-value">
          {{ fileSize ? readableFileSize(fileSize) : $t("unknown") }}
        </span>
      </div>
      <div
        v-for="(item, index) in additionalInfoItems"
        :key="item.name"
        :class="'info-row' + (index % 2 === 0 ? ' background-accent' : '')" 
      >
        <span class="info-label">{{ item.label }}:</span>
        <span class="info-value">{{ item.value ? item.value : $t("unknown") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  bytesToMegabytes,
} from "@/helpers/conversions";

export default {
  name: "FileDetailsDisplay",
  props: {
    fileName: {
      type: String,
      default: null,
    },
    fileSize: {
      type: Number,
      default: null,
    },
    additionalInfoItems: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    readableFileSize(bytes) {
      return bytesToMegabytes(bytes);
    },
  },
}
</script>

<style lang="scss" scoped>
.file-info-title,
.info-row {
  color: var(--v-primaryText-base);
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: $font-spacing;
}

.background-accent {
  background-color: var(--v-secondaryBackground-base);
}

.file-info-container {
  border-radius: 8px;
  border: 1px solid var(--v-lightBackground-base);
  overflow: hidden;

  .info-row {
    border-bottom: 1px solid var(--v-lightBackground-base);
  }

  .info-row:last-of-type {
    border-bottom: none;
  }
}

.info-row {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  line-clamp: 1;
}

.info-label {
  color: var(--v-secondaryText-base);
  margin-right: 4px;
}

.info-value {
  font-weight: 400;
}
</style>